import React, { useState } from "react";
import { useTransaksi } from "../../context/transaksiContext";
import {
    Card,
    Button,
    Box,
    Stack,
    Typography,
    TextField,
    Avatar,
    Grid,
    useMediaQuery,
    SelectChangeEvent,
    Select,
    MenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import toRupiah from "../../utils/toRupiah";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import avatarAlt from "../../utils/avatarAlt";
import { DetailBundling, ICart } from "../../constants/types";
import "./CardPesan.css";
import useUser from "../../services/queries/useUser";
import toRupiahDesimal from "../../utils/toRupiahDesimal";
interface ICardPesanProps {
    id: number;
    namaBarang: string;
    sku: string;
    harga: number;
    url: string;
    qty: number;
    jumlahStok: number | undefined;
    detailBundling: DetailBundling[] | [];
    hpp: {
        id: number;
        faktur: string;
        hargaBeli: number;
        jumlah: number;
    }[];
    multipleHarga: {
        id: number;
        harga: number | string;
        keterangan: string | null;
    }[];
    dpp: number | string;
}

const CardPesan = ({
    id,
    namaBarang,
    sku,
    harga,
    url,
    qty,
    jumlahStok,
    detailBundling,
    hpp,
    multipleHarga,
    dpp,
}: ICardPesanProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const { handleUpdate, handleRemove } = useTransaksi();
    const { data: user } = useUser();
    const [selectedHarga, setSelectedHarga] = useState(
        multipleHarga.length > 0 ? multipleHarga[0].harga : harga,
    );

    const addToCart = (data: ICart) => {
        if (data.qty >= 0) {
            handleUpdate({ ...data });
        } else {
            handleRemove({ ...data });
        }
    };

    const handleChange = (event: SelectChangeEvent) => {
        setSelectedHarga(event.target.value);
        console.log(event.target.value);
        addToCart({
            id,
            namaBarang,
            sku,
            harga: Number(event.target.value),
            url,
            jumlahStok,
            qty,
            detailBundling,
            hpp,
            faktur: [],
            multipleHarga,
            dpp,
        });
    };

    let valueQty = "0";
    let strQty = String(qty).replace(/^0+/, "");
    if (strQty[0] === "") {
        valueQty = "0";
    } else {
        valueQty = String(qty);
    }

    const incNum = () => {
        if (Number(jumlahStok) > qty || jumlahStok === null) {
            addToCart({
                id,
                namaBarang,
                sku,
                harga,
                url,
                jumlahStok,
                qty: qty + 1,
                detailBundling,
                hpp,
                faktur: [],
                multipleHarga,
                dpp,
            });
        }
    };

    const decNum = () => {
        if (qty >= 0) {
            addToCart({
                id,
                namaBarang,
                sku,
                harga,
                jumlahStok,
                url,
                qty: qty - 1,
                detailBundling,
                hpp,
                faktur: [],
                multipleHarga,
                dpp,
            });
        } else {
            addToCart({
                id,
                namaBarang,
                sku,
                harga,
                jumlahStok,
                url,
                qty: -1,
                detailBundling,
                hpp,
                faktur: [],
                multipleHarga,
                dpp,
            });
        }
    };

    const detailItemSatuan = detailBundling
        .map((li) => `${li.namaBarang} (${li.jumlahYangDiambil})`)
        .join(", ");

    return (
        <Card
            variant="outlined"
            sx={{
                marginBottom: 1,
                padding: isTabletScreen ? 1 : 2,
            }}
        >
            <Box display="grid" className="card-pesan">
                <Stack
                    direction="row"
                    spacing={isTabletScreen ? 0.5 : 1}
                    alignItems="flex-start"
                    gridColumn={isPhoneScreen ? "1 / 3" : "unset"}
                >
                    <Avatar
                        sx={{
                            display: isTabletScreen ? "none" : undefined,
                            backgroundColor: "primary.main",
                            width: 65,
                            height: 70,
                        }}
                        variant="rounded"
                        alt={namaBarang}
                        src={url}
                    >
                        {avatarAlt(namaBarang)}
                    </Avatar>
                    <Box flexDirection="column" width="100%">
                        <Typography
                            variant={isTabletScreen ? "body2" : "subtitle2"}
                            fontWeight={isTabletScreen ? 500 : "bold"}
                        >
                            {namaBarang}
                        </Typography>
                        <Typography fontSize={12} color="#76747C">
                            {detailItemSatuan}
                        </Typography>
                        <Grid container my={isTabletScreen ? 0.5 : 1}>
                            <Grid item>
                                {user && user.akses.transaksi.includes(14) ? (
                                    multipleHarga.length > 1 ? (
                                        <Select
                                            placeholder="Pilih Stok"
                                            margin="dense"
                                            size="small"
                                            onChange={handleChange}
                                            value={String(selectedHarga)}
                                            sx={{
                                                height: "14px",
                                                minHeight: "unset",
                                                fontSize: "12px",
                                                paddingY: "14px",
                                            }}
                                            fullWidth
                                        >
                                            {multipleHarga.map((li) => (
                                                <MenuItem value={li.harga}>
                                                    {`${toRupiahDesimal(
                                                        Number(li.harga),
                                                    )} ${
                                                        li.keterangan ===
                                                            "-''-" ||
                                                        li.keterangan === null
                                                            ? ""
                                                            : `(${li.keterangan})`
                                                    }`}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    ) : multipleHarga.length === 1 ? (
                                        <Typography
                                            fontSize={12}
                                            color="#76747C"
                                            fontWeight="bold"
                                        >
                                            {`${toRupiahDesimal(
                                                Number(multipleHarga[0].harga),
                                            )}`}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            fontSize={12}
                                            color="#76747C"
                                            fontWeight="bold"
                                        >
                                            {toRupiah(harga)}
                                        </Typography>
                                    )
                                ) : multipleHarga.length > 1 ? (
                                    <Typography
                                        fontSize={12}
                                        color="#76747C"
                                        fontWeight="bold"
                                    >
                                        {`${toRupiahDesimal(
                                            Number(multipleHarga[0].harga),
                                        )}`}
                                    </Typography>
                                ) : multipleHarga.length === 1 ? (
                                    <Typography
                                        fontSize={12}
                                        color="#76747C"
                                        fontWeight="bold"
                                    >
                                        {`${toRupiahDesimal(
                                            Number(multipleHarga[0].harga),
                                        )}`}
                                    </Typography>
                                ) : (
                                    <Typography
                                        fontSize={12}
                                        color="#76747C"
                                        fontWeight="bold"
                                    >
                                        {toRupiah(harga)}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        {multipleHarga.length > 0 ? (
                            <Typography
                                variant="subtitle2"
                                color="primary"
                                fontWeight="bold"
                            >
                                {toRupiahDesimal(Number(selectedHarga) * qty)}
                            </Typography>
                        ) : (
                            <Typography
                                variant="subtitle2"
                                color="primary"
                                fontWeight="bold"
                            >
                                {toRupiah(harga * qty)}
                            </Typography>
                        )}
                    </Box>
                </Stack>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-end"
                    justifyContent="center"
                >
                    <Stack
                        direction="row"
                        width="100%"
                        spacing={1}
                        gridColumn={isPhoneScreen ? "1/3" : "unset"}
                        display="grid"
                        gridTemplateColumns="auto 1fr auto"
                    >
                        <Button
                            onClick={decNum}
                            variant="outlined"
                            sx={{
                                minWidth: "unset",
                                padding: "6px",
                                width: "fit-content",
                            }}
                        >
                            {qty === 0 ? (
                                <DeleteForeverIcon color="primary" />
                            ) : (
                                <RemoveIcon color="primary" />
                            )}
                        </Button>
                        <TextField
                            value={valueQty}
                            type="number"
                            size="small"
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                                addToCart({
                                    id,
                                    namaBarang,
                                    sku,
                                    harga,
                                    url,
                                    jumlahStok,
                                    qty: Number(event.target.value),
                                    detailBundling,
                                    hpp,
                                    faktur: [],
                                    multipleHarga,
                                    dpp,
                                });
                            }}
                            inputProps={{
                                style: {
                                    textAlign: "center",
                                    backgroundColor: "white",
                                    fontWeight: "bold",
                                    minWidth: "40px",
                                },
                            }}
                        />
                        <Button
                            disabled={
                                qty >= Number(jumlahStok) && jumlahStok !== null
                            }
                            onClick={incNum}
                            variant="contained"
                            sx={{
                                minWidth: "unset",
                                padding: "6px",
                                width: "fit-content",
                            }}
                        >
                            <AddIcon color="inherit" />
                        </Button>
                    </Stack>
                    <Grid mt={1}>
                        <Typography
                            fontSize={10}
                            color="#76747C"
                            fontWeight="bold"
                        >
                            {jumlahStok !== null
                                ? "max. " + jumlahStok
                                : "Tanpa Stok"}
                        </Typography>
                    </Grid>
                </Box>
            </Box>
            {qty > Number(jumlahStok) &&
                jumlahStok !== null &&
                qty !== null && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-end"
                    >
                        <Typography
                            color="red"
                            variant="subtitle2"
                            fontWeight="bold"
                        >
                            Jumlah pesanan melebihi stok
                        </Typography>
                    </Box>
                )}
        </Card>
    );
};

export default CardPesan;
